export enum ButtonSize {
  IS_SMALL = 'is-small',
  IS_MEDIUM = 'is-medium',
  IS_LARGE = 'is-large'
}
